import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m14.862 3.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L8.582 15.07a4.5 4.5 0 0 1-1.897 1.13L4 17l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L17.5 6.125M16 13v4.75A2.25 2.25 0 0 1 13.75 20H3.25A2.25 2.25 0 0 1 1 17.75V7.25A2.25 2.25 0 0 1 3.25 5H8",
  stroke: "#02504B",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }